var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoBlind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-986-22H164v754H-986z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    transform: "translate(24 30.312)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M76.868.673H3.132a2.44 2.44 0 0 0-2.44 2.44V33.55a2.44 2.44 0 0 0 2.44 2.44h11.717v36.985a2.44 2.44 0 0 0 4.878 0V29.58a2.981 2.981 0 0 1 2.975-2.975 2.981 2.981 0 0 1 2.976 2.975v28.108a2.44 2.44 0 0 0 4.878 0V47.17a2.981 2.981 0 0 1 2.976-2.976 2.981 2.981 0 0 1 2.975 2.976v10.517a2.44 2.44 0 0 0 4.878 0v-5.395a2.981 2.981 0 0 1 2.976-2.976 2.981 2.981 0 0 1 2.976 2.976v8.839a2.44 2.44 0 0 0 4.878 0v-3.425a2.981 2.981 0 0 1 2.975-2.975 2.981 2.981 0 0 1 2.976 2.975v15.278a2.44 2.44 0 0 0 4.878 0V57.698c0-4.332-3.522-7.854-7.854-7.854a7.872 7.872 0 0 0-3.18.673c-.8-3.483-3.932-6.088-7.649-6.088a7.816 7.816 0 0 0-3.239.703 7.867 7.867 0 0 0-10.566-5.23V36h46.312a2.44 2.44 0 0 0 2.44-2.439V3.122a2.442 2.442 0 0 0-2.44-2.449zm-2.439 30.44H30.556V29.58c0-4.331-3.522-7.853-7.854-7.853-4.331 0-7.853 3.522-7.853 7.853v1.532H5.57V5.552h68.858v25.56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.185 14.576c1.122 0 2.02-.908 2.02-2.02s-.907-2.02-2.02-2.02c-1.122 0-2.02.908-2.02 2.02s.908 2.02 2.02 2.02z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.132,
    cy: 12.556,
    r: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.132 20.712c1.122 0 2.02-.907 2.02-2.02 0-1.121-.908-2.019-2.02-2.019s-2.02.907-2.02 2.02c0 1.112.908 2.02 2.02 2.02zM55.015 20.712c1.122 0 2.02-.907 2.02-2.02 0-1.121-.908-2.019-2.02-2.019-1.122 0-2.02.907-2.02 2.02 0 1.112.898 2.02 2.02 2.02zM49.132 26.839c1.122 0 2.02-.907 2.02-2.02 0-1.112-.908-2.019-2.02-2.019s-2.02.907-2.02 2.02c0 1.112.908 2.019 2.02 2.019z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.912,
    cy: 12.556,
    r: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.912 20.712c1.122 0 2.02-.907 2.02-2.02 0-1.121-.908-2.019-2.02-2.019s-2.02.907-2.02 2.02c0 1.112.908 2.02 2.02 2.02zM65.912 26.839c1.122 0 2.02-.907 2.02-2.02 0-1.112-.908-2.019-2.02-2.019s-2.02.907-2.02 2.02c0 1.112.908 2.019 2.02 2.019zM32.185 20.712c1.122 0 2.02-.907 2.02-2.02 0-1.121-.907-2.019-2.02-2.019-1.122 0-2.02.907-2.02 2.02 0 1.112.908 2.02 2.02 2.02z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBlind);
export default __webpack_public_path__ + "static/media/ico-blind.aaca5a6c1ff162f888849149d87c82d7.svg";
export { ForwardRef as ReactComponent };